module.exports = __webpack_public_path__ + "static/media/switch-role.99e174dc.svg";